/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_mt_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markdown Table Generator — Aligned GFM Tables | Toolverse`)
};

const es_mt_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generador de Tablas Markdown — Tablas GFM Alineadas | Toolverse`)
};

const de_mt_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markdown-Tabellengenerator — Ausgerichtete GFM-Tabellen | Toolverse`)
};

const nl_mt_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markdown Tabel Generator — Uitgelijnde GFM-tabellen | Toolverse`)
};

const fr_mt_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markdown Table Generator — Tableaux GFM alignés | Toolverse`)
};

const it_mt_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generatore di tabelle Markdown — Tabelle GFM allineate | Toolverse`)
};

const pt_br2_mt_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerador de Tabelas Markdown — Tabelas GFM Alinhadas | Toolverse`)
};

const pt_mt_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerador de Tabelas Markdown — Tabelas GFM Alinhadas | Toolverse`)
};

const ja_mt_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markdown テーブルジェネレーター — 配置された GFM テーブル | Toolverse`)
};

const zh_mt_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markdown 表格生成器 — 对齐的 GFM 表格 | Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const mt_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.mt_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("mt_meta_title", locale)
	if (locale === "en") return en_mt_meta_title(inputs)
	if (locale === "es") return es_mt_meta_title(inputs)
	if (locale === "de") return de_mt_meta_title(inputs)
	if (locale === "nl") return nl_mt_meta_title(inputs)
	if (locale === "fr") return fr_mt_meta_title(inputs)
	if (locale === "it") return it_mt_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_mt_meta_title(inputs)
	if (locale === "pt") return pt_mt_meta_title(inputs)
	if (locale === "ja") return ja_mt_meta_title(inputs)
	return zh_mt_meta_title(inputs)
};